import { Col, Row } from 'antd';

const OverlayTags = ({ book, tagColors }) => (
  <Row>
    <Col span={24} style={{ display: 'flex' }} className='col-tag'>
      {book['Primary Tags']?.split(',').map((tag, index) => {
        const colorIndex = index % tagColors.length;

        return (
          tag.trim().length > 0 && (
            <div
              className='overlay-tags'
              key={tag}
              style={{ backgroundColor: tagColors[colorIndex] }}
            >
              {tag.trim()}
            </div>
          )
        );
      })}

      {book['Secondary Tags']?.split(',').map((tag, index) => {
        const colorIndex =
            (index + (book['Primary Tags']?.split(',')?.length || 0)) %
            tagColors.length;

        return (
          tag.trim().length > 0 && (
            <div
              className='overlay-tags'
              key={tag}
              style={{ backgroundColor: tagColors[colorIndex] }}
            >
              {tag.trim()}
            </div>
          )
        );
      })}
    </Col>
  </Row>
);

export default OverlayTags;